export default __webpack_public_path__ + "static/media/moonsail_capital.1b57c0ba.png";